/* Product Tile Markup - You can play around with this to change the
information that appears on the Wishlisted Product tiles  */
const renderTemplateString = (p) => {
	const strElem = `
	<div aria-label="${p.dt}" class="swym-wishlist-item swym-is-anchor main-wishlist__item">
		<a href="${p.du}" class="swym-wishlist-image-wrapper item__image-wrapper">
			<img alt="" class="swym-wishlist-image" src="${p.iu}">
		</a>
		<button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="${p.epi}" data-product-id="${p.empi}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button item__remove-btn">
			<svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12" fill="none">
			<path d="M11.5001 0.99991C9.48411 -0.319637 7.31137 1.00356 6.80738 2.10318C5.79894 1.00344 5.47252 0.0140861 2.99984 0.500009C0.220078 1.04628 0.784489 4.2951 1.26344 5.95198C2 8.5 5 10.5 6.9999 11.5C7.67189 11.1335 9.32735 10.3505 11.3433 8.15122C13.8633 5.40217 14.3769 2.8829 11.5001 0.99991Z" fill="#DA3A25"/>
			<path d="M4.00008 0C1.81698 0 0.351634 1.81735 0.250183 3.68391C0.249939 3.69127 0.249939 3.69862 0.250183 3.70597C0.250183 6.31847 1.92543 8.38525 3.56064 9.78884C5.19585 11.1924 6.83008 11.9617 6.83008 11.9617C6.88273 11.9869 6.94095 12 7 12C7.05905 12 7.11727 11.9869 7.16992 11.9617C7.16992 11.9617 8.80415 11.1924 10.4394 9.78884C12.0746 8.38525 13.7498 6.31847 13.7498 3.70597C13.7501 3.69862 13.7501 3.69127 13.7498 3.68391C13.6484 1.81735 12.183 0 9.99992 0C8.62966 0 7.5839 0.65319 7 1.53313C6.4161 0.65319 5.37034 0 4.00008 0ZM4.00008 0.7059C5.38998 0.7059 6.31633 1.48323 6.64259 2.40447C6.6667 2.47588 6.71433 2.53822 6.77859 2.58246C6.84284 2.6267 6.92039 2.65055 7 2.65055C7.07961 2.65055 7.15716 2.6267 7.22141 2.58246C7.28567 2.53822 7.3333 2.47588 7.35741 2.40447C7.68367 1.48323 8.61002 0.7059 9.99992 0.7059C11.7309 0.7059 12.9083 2.16398 12.9998 3.70597C13.0001 3.70963 12.9996 3.71335 12.9998 3.717C12.9998 3.71887 12.9998 3.72065 12.9998 3.72252C12.9925 6.0415 11.4839 7.93583 9.93547 9.26493C8.51932 10.4805 7.23709 11.1177 7 11.2337C6.76291 11.1177 5.48068 10.4805 4.06453 9.26493C2.51609 7.93584 1.00746 6.0415 1.00016 3.72252C1.00026 3.72068 1.00006 3.71882 1.00016 3.717C1.00015 3.71324 1.00016 3.70973 1.00016 3.70597C1.09173 2.16398 2.26914 0.7059 4.00008 0.7059Z" fill="#EA0029"/>
			</svg>
		</button>
		<div class="item__product-info">
			${p.vendor ? `<div class="swym-variant-title swym-text swym-title-2">${p.vendor}</div>` : ""}
			<h3 class="swym-title swym-title-1">${p.dt}</h3>
			<div class="swym-product-price swym-text swym-text-1">
				${!p.op || p.op === p.pr
					?
						`<div class="swym-product-original-price swym-value">
							&#36;${p.pr}
						</div>
						`
					:
						`
							<div class="swym-product-final-price swym-value">
								&#36;${p.pr}
							</div>
							<div class="swym-product-compare-at-price swym-value">
								&#36;${p.op}
							</div>
						`
				}
			</div>
			<button
				id="swym-custom-add-toCartBtn"
				data-state-cart="${p.isInCart ? 'swym-added' : ''}"
				data-product-url="${p.du}"
				data-variant-id="${p.epi}"
				data-product-id="${p.empi}"
				${p.available ? '' : 'disabled'}
				class="swym-add-to-cart-btn swym-button swym-button-1 swym-is-button swym-is-button item__add-to-cart-btn"
			>
				${
					p.available ? (p.isInCart ? '<span>Added to cart</span>' : '<span>Add to cart</span>') : 'Sold out'
				}
			</button>
		</div>
		</div>
	`
	return new DOMParser().parseFromString(strElem, 'text/html').body.childNodes[0];
}

function getVariantInfo(variants) {
	try {
		let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
			variantinfo;
		if (variantKeys.length > 0) {
			variantinfo = variantKeys[0];
			if (variantinfo == "Default Title") {
				variantinfo = "";
			}
		} else {
			variantinfo = "";
		}
		return variantinfo;
	} catch (err) {
		return variants;
	}
}

function fetchCart() {
	const cartDrawer = document.querySelector('cart-drawer');
	fetch(`/cart?section_id=${cartDrawer.getAttribute("section")}`)
		.then((res) => res.text())
		.then((cartContent) => {
			const div = document.createElement("div");
			div.innerHTML = cartContent;
			cartDrawer.innerHTML = div.querySelector("cart-drawer").innerHTML;
			cartDrawer.classList.remove("is-empty");
			cartDrawer.classList.add("active");
		}).catch(e => console.warn(e))
}

function onAddToCartClick(e) {
	e.preventDefault();
	const productId = e.currentTarget.getAttribute("data-product-id");
	const variantId = e.currentTarget.getAttribute("data-variant-id");
	const du = e.currentTarget.getAttribute("data-product-url");
	e.target.innerHTML = "Adding..";
	window._swat.replayAddToCart({
		empi: productId,
		du: du
	}, variantId, (c) => {
		e.target.innerHTML = "Added to Cart";
		e.target.setAttribute("data-state-cart", "swym-added");
		fetchCart();
	}, (err) => {
		console.error(err);
		e.target.innerHTML = "Add to Cart";
		alert("This variant is out of stock");
	});
}

function onRemoveBtnClick(e) {
	e.preventDefault();
	var epi = +e.currentTarget.getAttribute("data-variant-id");
	var empi = +e.currentTarget.getAttribute("data-product-id");
	window._swat.fetch((products) => {
		products.forEach((product) => {
			if (epi && empi && product.epi == epi && product.empi == empi) {
				window._swat.removeFromWishList(product, function () {
					if (!window.SwymCallbacks) {
						window.SwymCallbacks = [];
					}
					window.SwymCallbacks.push(swymRenderWishlist);
				});
			}
		});
	})
}

function swymRenderWishlist(swat) {
	// Get wishlist items
	document.getElementById("wishlist-items-count").innerHTML = "Loading ...";
	document.getElementById("wishlist-items-container").innerHTML = "";

	swat.fetch(async (products = []) => {

		const promise = await Promise.all([
			...products.map((p) =>
				fetch(`${p.du}.js`, {
					headers: {
						"Content-Type": "application/json",
					},
				}).then((res) => res.json())
			),
		]);

		const wishlistContentsContainer = document.getElementById("wishlist-items-container");

		const formattedWishlistedProducts = products.map((p, index) => {
			const newP = SwymUtils.formatProductPrice(p);
			newP.isInCart = _swat.platform.isInDeviceCart(p.epi) || p.et == _swat.EventTypes.addToCart;
			newP.variantinfo = p.vi ? getVariantInfo(p.vi) : "";
			newP.tags = promise[index].tags;
			newP.vendor = promise[index].vendor;
			newP.available = promise[index]?.variants?.find(variant => variant.available)
			return newP
		});

		if (wishlistContentsContainer) {
			formattedWishlistedProducts.forEach(product => {
				wishlistContentsContainer.appendChild(renderTemplateString(product));
			})

			const text = products.length ? `${products.length > 1 ? products.length + " products" :  "1 product"}` : "Your wishlist is currently empty";
			document.getElementById("wishlist-items-count").innerHTML = text;
			attachClickListeners();
		} else {
			console.error("Container not found, Wishlist Page element not found");
		}
	}, () => {
		document.getElementById("wishlist-items-count").innerHTML = "Something went wrong. Please try again";
	});
}

function attachClickListeners() {
	var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
	var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
	//   Add to cart Btns
	for (var i = 0; i < addToCartButtons.length; i++) {
		if (!addToCartButtons[i].getAttribute("disabled")) {
			addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
		}
	}
	//   Remove Buttons
	for (var k = 0; k < removeBtns.length; k++) {
		removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
	}
	console.log("Events attached!");
}

if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */